export default {
  Tips_Common: {
    non_system_interface: '非本系统的接口',
    bad_request: '请求错误',
    relogin: '请重新登录',
    request_404: '请求地址404',
    request_timeout: '请求超时',
    system_unavailable: '系统暂不可用，请稍后重试或联系工作人员',
    login_invalid: '登陆信息已失效，请重新登录',
    account_other_login: '账号在其他地方登录',
    unknown_error: '未知错误',
    // err_network: '网络异常，请检查网络连接',
    request_error: '请求失败',
    Changes_Clinic_Settings: '正在修改诊所诊治设置，是否保存？',
    Cntrols_Successfully: '操作成功',
    Input_Promotion_Name: '请输入转介码名称',
    Input_Promotion_Code: '请输入转介码',
    select_yishi: '请选择医师',
    select_shouquan_yishi: '请选择授权医师',
    shouquan_same_yishi: '授权医师不能和医师相同',
    shouquan_example_tip: '* 示例：李四（医师）—杨一（授权医师）',
    reset_successfully: '重置成功',
    edit_successfully: '修改成功',
    add_successfully: '新增成功',
    complete_certificate: '请完善证书列表',
    has_confirm_shutdown: '数据发生了修改，确认关闭？',
    enter_account: '请输入账号',
    must_account_less: '账号长度不能少于6',
    must_account_than: '账号长度不能大于20',
    must_account_fomat: '格式为单一或任意组合的字母数字和字符_-@.并且长度为6~20',
    format_error: '输入格式错误',
    enter_id: '请输入证件号码',
    must_id_less: '证件号码长度需大于等于0',
    perfect_source: '请先完善号源',
    file_format_incorrect: '文件格式不正确, 请上传jpeg、png或pdf格式文件',
    enter_name: '请输入姓名',
    enter_phone: '请输入手机号',
    select_birth: '请选择出生日期',
    select_doctor_category: '请选择医师类型',
    select_sex: '请选择性别',
    select_scheduling: '请选择是否排班',
    enter_describe: '请输入描述',
    select_cert_type: '请选择证书类型',
    enter_certificate_numb: '请输入证书编号',
    enter_certificate_title: '请输入证书名称',
    select_issue_date: '请选择发证时间',
    upload_attachment: '请上传附件',
    search_menu: '搜索菜单',
    full_screen: '全屏',
    full_screen_out: '退出全屏',
    content_recovery: '内容区复原',
    content_enlargement: '内容区放大',
    content_full_screen: '内容区全屏',
    deleting_role: '正在删除角色',
    confirm_deletion: '确认删除',
    del_successfully: '删除成功',
    input_bag_time: '请输入包/次',
    input_g_bag: '请输入克/包',
    bag_time_need: '包/次不可为0',
    g_bag_need: '克/包不可为0',
    method_need: '请至少选择一种支付方式',
    postage_need: '请输入邮费',
    cannot_null: '电子秤设定值不可为空！',
    end_equal_start: '电子秤设定结束值必须等于下一阶段的开始值！',
    config_save_no: '正在修改诊所配置，是否保存？',
    config_save_no_logout: '正在修改诊所配置，保存后将退出登录，是否确定？',
    save_successfully: '保存成功',
    err_network: '网络错误，请稍后重试',
    loading: '加载中',
    discount_example: '80% = 8折',
    denomination_need: '请输入面额',
    discount_need: '请输入折扣',
    enter_coupon_name: '请输入优惠券名称',
    enter_setmeal_name: '请输入套票名称',
    select_is_coupon: '请选择是否优惠券',
    select_coupon_type: '请选择优惠券类型',
    select_is_enable: '请选择是否启用',
    enter_amount: '请输入金额',
    select_scope_use: '请选择使用范围',
    denomination_less_amount: '面额必须小于满减目标金额',
    min_warning_less_max: '最小预警量必须小于最大预警量',
    sliding_expiry_hint: '自发放日起 {duration}{unit}后过期',
    taopiao_sliding_expiry_hint: '自购买日起 {duration}{unit}后过期',
    enter_expiration_duration: '请输入过期时长',
    expiration_duration_range: '过期时长需在1-{max}{unit}之间（最长10年）',
    select_expiration_time: '请选择过期时间',
    expiration_time_before_sale_end: '固定日期过期不能早于售卖结束日期',
    expiration_time_before_today: '固定日期过期不能早于今天',
    end_time_before_start_time: '结束时间不能早于开始时间',
    select_expiration_type: '请选择过期类型',
    deleting_project: '正在删除项目',
    attachment_load: '附件上传中，请稍后',
    information_backfill: '当前证件号码存在用户信息，是否回填',
    cannot_activated: '此药品平台已停用，需启用请联系平台管理者',
    select_address: '请选择地址信息',
    tips_address: '详细地址长度需要在2-120个汉字或字符, 不能包含表情符号',
    use_default: '是否确认设置为默认地址',
    enter_pingyin: '请输入中文或拼音',
    enter_code: '请输入编码',
    enter_price: '请输入售价',
    enter_min_whole: '请输入最少单位量',
    enter_max_whole: '请输入最大单位量',
    complete_order: '是否完结当前订单？',
    order_completed: '订单已完成',
    cancel_successfully: '取消成功',
    no_record: '暂无签收记录',
    no_data: '暂无数据',
    enter_opinion: '请输入审批意见',
    audit_completed: '审核完成',
    enter_description: '请输入项目描述',
    cannot_empty: '订单不可为空',
    submit_successfully: '提交成功',
    clear_order_list: '确认清空订单列表',
    temporary_successfully: '暂存成功',
    bring_quantity: '一键带入下单数量',
    least_one_drug: '至少需要签收一样药品！',
    confirm_receipt: '确认签收订单',
    continue_sign: '签收数量为0，是否继续签收',
    sign_successfully: '签收成功',
    expired_continue_sign: '药品已过了有效期，是否继续签收',
    sign_remaining_all: '是否签收全部剩下下单数量',
    invalid_barcode: '无效的码',
    not_onpurchase: '药品不在采购列表中',
    signings_not_exceed: '签收数量不可多于下单数量',
    whether_backfill: '当前证件号存在用户信息，是否回填',
    enter_prepaid_name: '请输入级别名称',
    select_level: '请选择级别',
    enter_discount: '请输入级别优惠',
    enter_discount_zero: '级别优惠不能为0',
    enter_threshold: '请输入起步金额',
    enter_threshold_zero: '起步金额不能为0',
    deleting_card: '正在删除储值级别',
    level_exists: '级别已存在',
    starting_exists: '起步金额已存在',
    confirm_report: '确定上报',
    cntrols_successfully: '操作成功',
    no_standard: '没有配置标准',
    sign_first: '请先签名',
    report_first: '上报成功',
    be_un_inequality: '两次输入的新密码不一致',
    KeKong_BuXiuGai: '可空不修改，不填则维持原样',
    password_length_max: '密码长度不能超过16位',
    confirm_delete_group: '删除当前组会将连带关联的收费规则及收费项目一起删除，是否确认删除',
    confirm_delete_rule: '删除当前规则会将连带关联的收费项目一起删除，是否确认删除',
    set_default: '是否确认设置为默认收费类别',
    use_price: '使用药物的售价收费',
    use_cost: '使用药物的成本收费',
    use_ticket: '使用套票的售价收费',
    use_fee: '使用医师的诊金收费',
    edit_print: '正在修改打印配置，是否保存',
    pay_modify: '预设开启后收费信息不可编辑',
    enter: '请输入',
    sku_exists: '药品已经存在',
    complete_dosage: '请完善药品用量',
    acupoint_exists: '穴位已经存在',
    drug_detail: '详情(使用饮片用量)',
    confirm_syncing: '是否确定同步药品信息至当前产品',
    empty_no: '不可为空',
    prefix_repeat: '字头不可重复',
    un_down_data: '当前没有可下载的数据',
    complete_rule: '请完善规则列表！',
    input_name_code: '支持产品名称、编码搜索',
    input_name_code_phone: '支持客户编号、证件号码、姓名、电话搜索',
    input_code_name_phone: '支持证件号码、姓名、电话搜索',
    input_name_en: '请输入中文姓名或者英文姓名',
    birthday_out: '出生日期不可超过今天',
    electronic_empty: '电子秤设定值不可为空',
    start_next: '电子秤设定结束值必须等于下一阶段的开始值',
    input_type: '请输入类别',
    source_get_tips1: '* 将生成新号源，请确定是否覆盖旧号源。',
    source_get_tips2: '覆盖（从第二天开始生成）',
    source_get_tips3: '不覆盖（从最后号源的第二天开始生成）',
    no_chinese_id: '证件号码不可输入中文',
    no_chinese: '不可输入中文',
    complete_certificate_list: '请完善证书列表！',
    openTime_closeTime_no: '营业时间设定值不可为空！',
    openTime_closeTime_before: '营业时间的结束时间必须在开始时间之后！',
    openTime_pre_closeTime_after: '营业时间的开始时间必须在上一阶段的结束时间之后！',
    days_cannot_empty: '天数不可为空！',
    frequency_cannot_empty: '每天/次不可为空！',
    confirm_delete: '是否确认删除？',
    QueRen_BaoCun: '确认保存？',
    QueRen_YanQi: '是否确认延期？',
    QueRen_She_YouXiaoQi: '是否确认设置有效期？',
    QueRen_YanQi_Zhi: '是否确认延期至 {date}？',
    QueRen_She_YouXiaoQi_Zhi: '是否确认设置有效期至 {date}？',
    ChuFang_ChaoGuo: '处方数量超过两条，是否继续套用？',
    TuPian_Jpg_Png: '图片必须是jpeg或者png格式！',
    TuPian_Size_2MB: '图片大小必须小于2MB！',
    TuPian_Size_5MB: '图片大小必须小于5MB！',
    FuJian_Size_10MB: '附件大小必须小于10MB！',
    HaoYuan_save_no: '正在修改诊症号源，是否保存？',
    ChaoJi_GuanLiYuan_Ming: '不可以使用超级管理员作为角色名！',
    apply_last_scheduling: '检测到上次排班数据，是否套用？',
    interval_save_no: '修改每节时间将会清空当前诊所的所有排班以及原有排班规则，是否继续？',
    source_day_max: '生成号源天数不能超过720天',
    interval_changed: '每节时间发生改变，将清空排班规则及已生成的号源！',
    no_set_ratio: '没有设置浓度',
    use_precious: '使用药物的名贵药材附加收费！',
    effective_upon_next_login: '修改成功，下次登录后生效',
    delete_successfully: '删除成功',
    start_time_cannot_be_after_end_time: '开始时间不能晚于结束时间',
    cannot_delete_use: '已使用禁止删除',
    cannot_delete: '不可删除',
    cannot_delete_reservation: '存在预约禁止删除',
    select_clinic: '请选择诊所',
    select_change_time: '请选择变动时间',
    hebing_tuijian_tip: '勾选快捷推荐（电话/姓名/证件号码）或输入关键字搜索，再自行勾选待合并患者',
    // ===== 简体迁移：硬编码提示语收编（2026-09-23） =====
    QueRen_KaiYong: '确认启用？',
    QueRen_TingYong: '确认停用？',
    QueRen_KaiYong_PaiBan: '确认启用排班？',
    QueRen_TingYong_PaiBan: '确认停用排班？',
    QueRen_ShanChu_JiaoSe: '正在删除角色：{name}，确认删除？',
    QueRen_ShanChu_CaiDan: '正在删除菜单：{name}，确认删除？',
    QueRen_ShanChu_XiangMu: '正在删除项目：{name}，确认删除？',
    QueRen_ShanChu_TaoPiao: '正在删除套票：{name}，确认删除？',
    QueRen_ShanChu_YouHuiQuan: '正在删除优惠券：{name}，确认删除？',
    QueRen_ShanChu_HuoDong: '正在删除活动：{name}，确认删除？',
    QueRen_ShanChu_HuanZhe: '正在删除患者档案：{name}，确认删除？',
    QueRen_ShanChu_TiaoZheng: '正在删除调整记录，确认删除？',
    QueRen_ShanChu_CaiGouDan: '正在删除采购单，确认删除？',
    QueRen_ShanChu_PanDian: '正在删除盘点记录，确认删除？',
    QueRen_ShanChu_PiCi: '正在删除批次号，确认删除？',
    QueRen_ShanChu_ZhuanJieMa: '正在删除转介码：{name}，确认删除？',
    ZhengZai_ShanChu_ShouQuan: '正在删除：【{staff}】对【{toStaff}】的授权，确认删除？',
    ZhengZai_ShanChu_ShouQuan_HuanZhe: '正在删除：患者【{patient}】对【{toStaff}】的授权，确认删除？',
    QueRen_QuXiao: '确认取消[{orderNo}]？',
    QueRen_QuXiao_CaiGouDan: '确认取消采购单[{orderNo}]？',
    QingXuanZe_YingYeDiDian: '请选择具体营业地点！',
    QingWanShan_YaoPinGuiGe: '请完善药品规格信息！',
    QingWanShan_ChengFenYao: '请完善成分药列表！',
    QingWanShan_MingGuiYao: '请完善名贵药材附加收费信息！',
    QingWanShan_GuiZeLieBiao: '请完善{types}规则列表！',
    QingBuQuan_ShiYongCiShu: '请补全使用次数或优惠金额限制，且不可为0！',
    TaoPiao_XiangMu_WeiKong: '套票项目不能为空！',
    QingXuanZe_YaoPin: '请选择药品！',
    QingXuanZe_ShangPin: '请选择商品！',
    CunZai_WuXiao_YaoPin: '存在无效药品，不可保存！',
    QingXuanZe_FaFang_KeHu: '请选择想要发放的客户！',
    QingShuRu_FaFangShuLiang: '请输入给每个客户发放的优惠券数量：',
    ZhengZai_FaFang_YouHuiQuan: '正在发放优惠券：{name}',
    QueRen_FaFang_QuanBu: '正在发放优惠券：{name}，每个客户发放{quantity}张，确认发放给全部客户？',
    QueRen_FaFang: '正在发放优惠券：{name}，每个客户发放{quantity}张，确认发放？',
    YaoPin_YiGuoQi: '药品已过期，是否继续加入？',
    Deng_YaoPin: ' 等药品',
    ChengBenJia_WeiKong: '成本价不可为0或空',
    XiaDanShuLiang_WeiKong: '下单数量不可为0或空',
    QingXuanZe_ShiJianFanWei: '请选择时间范围',
    KaiShi_BuNeng_DaYu_JieShu: '开始时间不能大于结束时间',
    BuNeng_ChaXun_ChaoYiNian: '不能查询超过一年的时间段',
    QingXuanZe_ShiJian: '请选择时间',
    ChuCun_ShiBai: '储存失败',
    ShengCheng_HaoYuan_Tip: '是否立即为当前医师生成该诊所的预约号源？',
    ShengCheng_HaoYuan_Last: '确定根据当前医师最后一次保存的排班规则生成预约号源？',
    QingKong_HaoYuan_Tip: '当前操作将清空该医师在此诊所之前配置的所有号源，是否继续？',
    MeiJie_QieHuan_Tip: '每节时间切换为{minutes}分钟，将自动调整号源时间，请确认是否继续？',
    QingShuRu_HaoYuanTianShu: '请输入生成号源天数！',
    ZuBie_WeiKong: '组别设定值不可为空',
    ZuBie_JieShu_BuPiPei: '组别设定结束值必须等于下一阶段的开始值',
    ZhongXinDengLu_ShengXiao: '本次修改将在重新登录后生效，确认修改？',
    TingYong_WuFa_HuiFu: '停用后将无法再次启用，确认？',
    MiMa_BuYiZhi: '两次输入的新密码不一致！',
    XinMiMa_Tong_JiuMiMa: '新密码不能与旧密码一致！',
    YingYeShiJian_WeiKong: '营业时间的星期不可为空！',
    YingYeShiJian_ChenFu: '营业时间的星期不可重复！',
    ChongJian_SuoYin_Tip: '将清空并重建患者索引信息，重建成功前可能影响患者信息，是否确定？',
    ChangDu_7_Zhi_11: '长度在 7 到 11 个字符',
    Tian: '天',
    Yue: '个月',
    Nian: '年',
    Yuan: '元',
    ChaoGuo: '超过',
    Mei: '每',
    JiangShouFei: '收费',
    An_ZhongLiang_JiFei: '按重量计费',
    An_ChengBen_JiFei: '按成本计费',
    An_WeiShu_JiFei: '按味数计费',
    BingZhengZhi: '病-证-治',
    GongKai_SiYou_Tip: '公开 - 诊所中的任何人都可以查看',
    SiMi_SiYou_Tip: '私密 - 只有您自己可以查看',
    QingXianShuRu_BingMing: '请先输入病名',
    QingXianShuRu_ZhengXing: '请先输入证型',
    RenShen: '妊娠',
    JinZhi_Label: '禁止',
    JingGao_Label: '警告',
    ZhiBiao: '指标',
    LiShi_PaiBan: '历史排班',
    ZanWu_LiShi_PaiBan: '暂无历史排班数据',
    QuanBu_Label: '全部',
    GuiShu_Label: '归属',
    Zhou_Label: '周',
    FenChai_Dian: '分拆点',
    XuanZe_GuanLiYuan: '选择管理员',
    ShuRu_XingMing_DianHua: '输入姓名或电话',
    YouHuiQuan_FaFang_Title: '优惠券发放',
    KuCun_TiaoZheng_Title: '库存调整',
    JianYi_CaiGouLiang: '建议采购量',
    QieHuan_Label: '切换',
    GuanBi_Label: '关闭',
    Gong_N_Xiang: '共 {total} 项',
    SouSuo_CaiDan: '搜索菜单',
    SouSuo_JieGuo: '搜索结果',
    WuFa_JinRu_CaiDan: '无法通过搜索进入该菜单，请为对应的路由设置唯一的 Name',
    CaiDan_BiXu_CanShu: '该菜单有必填的动态参数，无法通过搜索进入',
    LiuLanQi_WuFa_GongZuo: '您的浏览器无法工作',
    YunXu_XinChuangKou: '请允许浏览器打开新窗口！',
    QuanPing_Label: '全屏',
    TuiChu_QuanPing: '退出全屏',
    BuJu_PeiZhi: '布局配置',
    GongNeng_PeiZhi: '功能配置',
    ChongZhi_Label: '重 置',
    XianShi_Logo: '显示 Logo',
    GuDing_Header: '固定 Header',
    XianShi_YeJiao: '显示页脚 Footer',
    ZuoCe_MoShi: '左侧模式',
    DingBu_MoShi: '顶部模式',
    HunHe_MoShi: '混合模式',
    DiTu_JiaZai_ShiBai: '地图加载失败，请检查高德Key配置',
    GaoDe_Key_WuXiao: '高德Key无效或未授权地理编码服务，请检查Key配置并开启安全密钥',
    DiLiBianMa_ShiBai: '地理编码失败：{info}',
    QingShuRu_DiZhi: '请输入地址',
    DiTu_WeiChuShiHua: '地图服务未初始化，请稍后重试',
    WeiZhaoDao_DiZhi: '未找到地址：{keyword}',
    QingXuanZe_DiDian: '请先选择一个地点',
    LuYouShouWei_CuoWu: '路由守卫过程发生错误',
    ZhiYeXuKeZheng_ZhengBen: '医疗机构执业许可证正本',
    ZhiYeXuKeZheng_FuBen: '执业许可证副本',
    ZhiYeXuKeZheng_NianJian: '执业许可证副本最新年检时间页',
    MinZhengJu_BeiAn: '民政局备案',
    YingYeZhiZhao: '营业执照',
    ZuZhi_JiGouDaiMa: '组织机构代码证',
    ShuiWu_DengJiZheng: '税务登记证',
    FangShe_ZhenLiaoXuKe: '放射诊疗许可证',
    FangShe_AnQuanXuKe: '放射安全许可证',
    XianJin_E_Song: '现金额（赠送）',
    Yuan_E_Song: '原金额（赠送）',
    LaiYuan_Label: '来源',
    ZhenSuo_MaoHao: '诊所：',
    FaFangShuLiang_CuoWu: '发放数量必须是1-5的非零正整数',
    FaFang_HaoShi_Tip: '发放全部时间比较久，请稍后...',
    FaFang_HouTai_Tip: '后台持续发放中，请于晚些时候刷新页面查看',
    TiaoMa_ErWeiMa_WeiKong: '条码、二维码不能同时为空！',
    QueRen_GengXin_YaoPin: '确认更新当前所有药品信息？',
    JiaoSe_XinXi_ShiBai: '角色信息获取失败',
    QuanXian_BaoCun_ChengGong: '角色权限保存成功',
    QuanXian_BaoCun_ShiBai: '角色权限保存失败',
    ChongJian_SuoYin_Label: '重建索引',
    HeBing_QueRen_Tip:
      '将把以下 {count} 位患者的病历及就诊信息合并到主患者【{name}】：{list}。合并后这些患者档案将被删除，且不可恢复，确定合并？',
    Zan_Wu_SouSuo_JieGuo: '暂无搜索结果',
    QingShuRu_HuoDong_JiaGe: '请填写每项商品的活动价格（可为 0，不可留空）',
    QingShuRu_HuoDong_ZheKou: '请填写每项商品的活动折扣（需大于 0，不可留空）',
    HuoDong_ZheKou_BuKe_Wei_Ling: '活动折扣不可为 0',
  },
}
